var exports = {
  "k": "x127c5a35--bc65ff--container",
  "V": "x127c5a35--bc65ff--empty_photo",
};

module.exports = exports;
